import { defineComponent, useCssModule } from '@nuxtjs/composition-api';
import { pluralize } from '~/utils';
export default defineComponent({
    name: 'FranchiseTariffCard',
    props: {
        data: {
            default: () => ({}),
            type: Object,
        },
    },
    emits: ['click'],
    setup(props, { emit }) {
        const css = useCssModule();
        const description = props.data?.description?.[0]?.data?.items || [];
        function handleClick() {
            emit('click', props.data.id);
        }
        return {
            css,
            description,
            handleClick,
            pluralize,
        };
    },
});
